import {
    GET_SETTINGS,
    GET_SETTINGS_SUCCESS,
    GET_SETTINGS_ERROR
} from '../actions';

const INIT_STATE = {
    list: null,
    loading: false,
    error: '',
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_SETTINGS:
            return { ...state, loading: true, error: '',   };
        case GET_SETTINGS_SUCCESS:
            return { ...state, loading: false, error: '', list: action.payload.list };
        case GET_SETTINGS_ERROR:
            return { ...state, loading: false, error: action.payload.message };       
        default: return { ...state };
    }
}
